import { useQuery } from '@tanstack/react-query';

import { TypesenseCollection } from '../types';
import { getProjectSelectOptionById } from './projects';
import { useGetTypeSenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';

const PROJECT_OPTION_KEY = 'projectOption';

export const useGetProjectOptionById = (id: number | string | undefined) => {
  const _id = id && typeof id === 'string' ? id : (id?.toString() ?? undefined);

  const { data: apiKeys } = useGetTypeSenseAPIKeys();
  const collectionApiKey =
    apiKeys?.[TypesenseCollection.PROJECTS_VIEW.keyName]?.key ?? null; // use _VIEW key here, if a user has no view access, it also has no higher access

  const { data, ...restProps } = useQuery({
    queryKey: [PROJECT_OPTION_KEY, _id, collectionApiKey],
    queryFn: () => getProjectSelectOptionById(_id!, collectionApiKey!),
    enabled: !!_id && !!collectionApiKey,
  });

  return { data, ...restProps };
};
